async function initMap() {
    // The location of map center
    const position = { lat: 41.919037, lng: 8.743517 };
    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerView } = await google.maps.importLibrary("marker");

    var mapSAV = document.getElementById('map');
    var bounds = new google.maps.LatLngBounds();
    var stores = JSON.parse(mapSAV.getAttribute('data-markers'));

    // The map centered
    map = new Map(document.getElementById("map"), {
        zoom: 4,
        center: position,
        mapId: "65c1be4e05bedff31e6cde93",
    });

    //Infowindow
    const infoWindow = new google.maps.InfoWindow();


    //The markers
    var markers = [];
    for (let [i, store] of stores.entries()) {
        var gps = store.gps.split(',');
        var coordinnates = new google.maps.LatLng(JSON.parse(gps[0].trim()), JSON.parse(gps[1].trim()));

        const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
            map,
            content: buildContent(store),
            position: coordinnates,
            title: store.name,
        });
        
        AdvancedMarkerElement.addListener("gmp-click", () => {
            toggleHighlight(AdvancedMarkerElement, store);
        });

        bounds.extend(coordinnates);
        markers[i] = AdvancedMarkerElement;
    }

    // cluster
    const renderer = {
        render: ({ count, position }) =>
        new google.maps.Marker({
            position: {
                lat: position.lat(),
                lng: position.lng(),
            },
            icon: {
              url: document.getElementById('map').getAttribute('data-cluster-icon'),
              scaledSize: new google.maps.Size(40, 40),
            },
            label: String(count),
        })
    };
    new markerClusterer.MarkerClusterer({
        markers,
        map,
        renderer
    });

    // infowindow
    function toggleHighlight(markerView, store) {
        if (markerView.content.classList.contains("highlight")) {
          markerView.content.classList.remove("highlight");
          markerView.zIndex = null;
        } else {
          markerView.content.classList.add("highlight");
          markerView.zIndex = 1;
        }
    }

    function buildContent(store) {
        const content = document.createElement("div");
        content.classList.add("storeContent");

        tempHTML = '<div class="icon"><img src="' + store.marker + '" /></div>';
        tempHTML += '<div class="details">';
        tempHTML += '<div class="heading">';
        tempHTML += '<span class="h3">' + store.name + '</span><img class="close-icon" src="' + document.getElementById('map').getAttribute('data-close-icon') + '"/>';
        tempHTML += '</div>';
        if (store.categories != "") {
            tempHTML += '<div class="info categories"><img src="' + document.getElementById('map').getAttribute('data-category-icon') + '"/>' + store.categories + '</div>';
        }
        if (store.address != "") {
            tempHTML += '<div class="info address"><img src="' + document.getElementById('map').getAttribute('data-address-icon') + '"/><span>' + store.address + '<br/>'+ store.zipcode +' '+ store.city +' ' + store.country + '</span></div>';
        }
        if (store.phone != "") {
            tempHTML += '<div class="info phone"><img src="' + document.getElementById('map').getAttribute('data-phone-icon') + '"/>' + store.phone + '</div>';
        }
        if (store.fax != "") {
            tempHTML += '<div class="info fax"><img src="' + document.getElementById('map').getAttribute('data-fax-icon') + '"/>' + store.fax + '</div>';
        }
        if (store.email != "") {
            tempHTML += '<div class="info email"><img src="' + document.getElementById('map').getAttribute('data-email-icon') + '"/>' + store.email + '</div>';
        }
        if (store.website != "") {
            tempHTML += '<div class="info fax"><img src="' + document.getElementById('map').getAttribute('data-website-icon') + '"/>' + store.website + '</div>';
        }
        if (document.getElementById('map').getAttribute('data-detail-page') === 'true') {
          tempHTML += '<a class="button button--primary" href="'+ store.detailpage +'">' + document.getElementById('map').getAttribute('data-detail-page-text') + '</a>';
        }
        tempHTML += '</div>';

        content.innerHTML = tempHTML;
          
        return content;
    }

    map.fitBounds(bounds);

}

initMap();